import React from "react";
import { NavLink } from "react-router-dom";
import { ChevronRight, LogOut, Sun, Moon } from "lucide-react";

const LOGO = "https://customer-assets-4nw71qhi.emergentagent.net/job_academia-control-3/artifacts/hiofilsr_LOGO%20AMERICANFIT.png";

const SUB = {
  "/": "Visão geral", "/consolidado": "Todas as unidades", "/venda-rapida": "Vender planos", "/alunos": "Cadastros e contratos",
  "/mapa-alunos": "Visualizar alunos", "/planos": "Gerenciar planos", "/treinos": "Prescrever treinos", "/biblioteca-exercicios": "Conteúdos de apoio",
  "/videos-american-fit": "Gerenciar vídeos", "/catraca": "Controle de acesso", "/caixa-dia": "Entradas e saídas", "/balanco-mensal": "Resultado do mês",
  "/pdv": "Vender produtos", "/avisos": "Avisos no portal", "/mural": "Recados da equipe", "/feedback-alunos": "Opiniões dos alunos",
  "/site-vendas": "Página de vendas", "/relatorios": "Números e listas", "/auditoria": "Ações registradas", "/seguranca": "Acessos e senhas",
  "/avisos-usuarios": "Recados da equipe", "/dispositivos": "Leitores e catracas", "/unidades": "Academias", "/usuarios": "Equipe e permissões",
  "/avaliacoes": "Notas da equipe", "/configuracoes": "Ajustes do sistema", "/migracao-nextfit": "Dados importados",
};

const ROLE = { admin: "Administrador", reception: "Recepção", trainer: "Personal", finance: "Financeiro" };

const Tile = ({ n, onGo, i }) => {
  const Icon = n.icon;
  return (
    <NavLink to={n.to} end={n.end} onClick={onGo} data-testid={`panel-${n.testid}`} style={{ animationDelay: `${i * 30}ms` }}
      className="af-panel-tile relative flex flex-col items-center justify-center text-center rounded-2xl border border-white/10 bg-[#111827]/90 px-2 pt-4 pb-5 min-h-[clamp(104px,30vw,140px)] active:scale-[.97] transition-transform">
      <Icon className="w-[clamp(28px,9vw,38px)] h-[clamp(28px,9vw,38px)] text-rose-500 mb-2" strokeWidth={1.8}/>
      <div className="font-heading text-[clamp(14px,4.3vw,18px)] font-bold text-white leading-tight">{n.label}</div>
      <div className="text-[clamp(10.5px,3vw,12.5px)] text-slate-400 mt-1 leading-snug">{SUB[n.to] || "Abrir"}</div>
      <ChevronRight className="absolute right-2 bottom-2 w-3.5 h-3.5 text-slate-500"/>
    </NavLink>
  );
};

export const MobilePanel = ({ items, user, theme, onToggleTheme, onClose, onHome, onLogout }) => (
  <div className="lg:hidden fixed inset-0 z-[70] bg-[#070A12] text-white flex flex-col h-[100dvh] af-safe-top" data-testid="mobile-panel">
    <div className="flex-1 min-h-0 overflow-y-auto overscroll-contain w-full max-w-[640px] mx-auto px-[clamp(12px,4.5vw,24px)] pb-4" style={{ WebkitOverflowScrolling: "touch" }}>
      <img src={LOGO} alt="American Fit" className="mx-auto w-[clamp(150px,56vw,260px)] pt-3 mix-blend-lighten" data-testid="mobile-panel-logo"/>
      <div className="flex items-center justify-between rounded-2xl border border-white/10 bg-[#111827]/90 px-4 py-3 mt-3 mb-4">
        <div>
          <div className="text-sm font-black uppercase tracking-wide">Painel administrativo</div>
          <div className="text-xs text-slate-400">Acesse as funções da sua academia</div>
        </div>
        <span className="flex items-center gap-1.5 text-xs font-bold uppercase text-rose-300 border border-rose-500/60 bg-rose-500/10 rounded-full px-3 py-1" data-testid="mobile-panel-role">
          <span className="w-2 h-2 rounded-full bg-rose-500"/>{user?.role}
        </span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-[clamp(8px,3vw,14px)]" data-testid="mobile-panel-grid">
        {items.map((n, i) => <Tile key={n.to} n={n} i={i} onGo={onClose}/>)}
      </div>
    </div>
    <div className="shrink-0 w-full bg-[#070A12] border-t border-white/10 shadow-[0_-8px_24px_rgba(0,0,0,.5)]" data-testid="mobile-panel-footer"
      style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 10px)" }}>
     <div className="w-full max-w-[640px] mx-auto px-[clamp(12px,4.5vw,24px)] pt-3">
      <div className="flex items-center justify-between gap-2">
        <div className="min-w-0">
          <div className="font-bold uppercase truncate" data-testid="mobile-panel-user">{user?.name}</div>
          <div className="text-xs text-slate-400">{ROLE[user?.role] || user?.role} · {user?.unit_name || "American Fit"}</div>
        </div>
        <button onClick={onToggleTheme} data-testid="mobile-panel-theme" className="flex items-center gap-1.5 text-xs text-rose-300 border border-rose-500/60 rounded-full px-3 py-1.5 shrink-0">
          {theme === "dark" ? <Sun className="w-3.5 h-3.5"/> : <Moon className="w-3.5 h-3.5"/>}{theme === "dark" ? "Modo claro" : "Modo escuro"}
        </button>
      </div>
      <div className="grid grid-cols-2 gap-3 mt-3">
        <button onClick={onHome} data-testid="mobile-panel-home" className="h-12 rounded-xl bg-rose-600 active:bg-rose-700 font-bold text-lg">Início</button>
        <button onClick={onLogout} data-testid="mobile-panel-logout" className="h-12 rounded-xl border border-white/10 bg-[#111827] font-bold text-lg flex items-center justify-center gap-2"><LogOut className="w-5 h-5"/>Sair</button>
      </div>
     </div>
    </div>
  </div>
);
